import { Component } from '@angular/core';

@Component({
	selector: 'app-request-paswor-page',
	templateUrl: './request-pasword-page.component.html',
	styleUrls: ['./request-pasword-page.component.scss']
})
export class RequestPaswordPageComponent {}
